import { render, staticRenderFns } from "./BuildingResult.vue?vue&type=template&id=3bc38aa6&scoped=true&"
import script from "./BuildingResult.vue?vue&type=script&lang=js&"
export * from "./BuildingResult.vue?vue&type=script&lang=js&"
import style0 from "./BuildingResult.vue?vue&type=style&index=0&id=3bc38aa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc38aa6",
  null
  
)

export default component.exports